import { formatAbbreviatedNumber } from '@/utils';
import styles from './index.module.scss';
import { Tooltip } from '@bfe/moly';
import { HelpIcon } from '@bfe/moly-icons';
import { justFormatNumber } from '@web3/base-utils';

interface Props {
  num: number;
}

export const AbbreviatedNumber = ({ num }: Props) => {
  return num >= 1e6 ? (
    <Tooltip
      title={justFormatNumber(num)}
      placement="bottom"
      trigger={['hover', 'click']}
      stopPropagation={true}
    >
      <div className={styles.wrapper}>
        {formatAbbreviatedNumber(num)}
        <HelpIcon className={styles.helpIcon} />
      </div>
    </Tooltip>
  ) : (
    <>{formatAbbreviatedNumber(num)}</>
  );
};
